
import { debounce } from "lodash";
import ArticleListCard from "@/components/pages/articles/ArticleListCard.vue";
import UiPagination from "~/components/UI/UiPagination";
import jsonLdMixin from "~/mixins/jsonLdMixin";
import SeoPagination from "~/components/seo/SeoPagination";

export default {
  components: {
    SeoPagination,
    ArticleListCard,
    UiPagination,
  },
  mixins: [jsonLdMixin],
  data() {
    return {
      articles: null,
      currentPage: this.$route.query?.page ? Number(this.$route.query.page) : 1,
      itemsOnPage: 9,
      totalPages: 1,
      loading: false,
      getPostDebounce: () => {},
    };
  },
  async fetch() {
    this.articles = await this.getPosts();
  },
  head() {
    const jsonLdPayload = this.setBlogListPageLdSchema();
    return {
      script: [
        {
          hid: this.getJsonLdScriptHid(jsonLdPayload),
          type: "application/ld+json",
          json: jsonLdPayload,
        },
      ],
    };
  },
  watch: {
    currentPage: {
      handler(newVal) {
        this.getPostDebounce();
      },
    },
    "$route.query.search"() {
      this.currentPage = 1;
      this.getPostDebounce();
    },
  },
  mounted() {
    this.getPostDebounce = debounce(async () => {
      this.articles = await this.getPosts();
      this.scrollToPlaceholder();
    }, 150);
  },
  methods: {
    scrollToPlaceholder() {
      const placeholderElement = document.querySelector(".scroll-placeholder");
      const header = document.querySelector(".header");
      let offsetPosition = 0;

      if (placeholderElement && header) {
        const headerHeight = header.offsetHeight;
        const elementPosition = placeholderElement.getBoundingClientRect().top;
        offsetPosition = elementPosition + window.pageYOffset - headerHeight + 1;
      }

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    },
    async getPosts() {
      try {
        const params = {
          page: this.currentPage,
          count: this.itemsOnPage,
          search: this.$route.query.search,
        };
        if (this.$route?.params?.section) {
          params.categories = [this.$route?.params?.section];
        }
        this.loading = true;
        const { data } = await this.$api.blog.getPosts(params);
        this.totalPages = data.meta.last_page;

        this.$store.commit("general/SET_JSON_SCHEMA_DATA", {
          posts: data.data,
        });
        return data.data;
      } catch (err) {
        console.log("err - ", err?.response?.data?.errors);
      } finally {
        this.loading = false;
      }
    },
    clickCallback(page) {
      this.currentPage = page;
      this.$router.replace({ query: { ...this.$route.query, page } });
      // this.$emit("changePage", page);
    },
  },
};
